const initialState = {
  attendance: [],
  loading: true
}

const  attendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "attendance_loading":
      return {
        ...state,
        loading: true
      };
    case "attendance":
      return {
        ...state,
        attendance: action.data,
        loading: false
      };
    default:
      return state
  }
}

export default attendanceReducer;